
const HowItWorksConsults = () => {
  return (
    <div>
      
    </div>
  )
}

export default HowItWorksConsults
